var _excluded = ["rowHeight", "className"],
    _excluded2 = ["rowHeight"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useMemo } from 'react';
import { isFunction } from '@okee-uikit/react-utils';
import { SELECTION_COLUMN_ID } from '../constants';
import { useTableRows } from '../row-data/row-info';
import { useTableExpansion, useTableTree } from '../row-data/active';
import { useTableColumns } from '../col-query/column-info';
import { useTableImplement, useTableCep } from '../implements/implement';
import { useTableSections } from '../implements/sections';
import { useTableColumnsWidth } from '../implements/size';
import { TableCell } from './cell';
import { TableRow } from './row';
export function TableBody(props) {
  var bodyRowHeight = props.rowHeight,
      className = props.className,
      attrs = _objectWithoutProperties(props, _excluded);

  var cep = useTableCep();
  var implement = useTableImplement();
  var rowsContext = useTableRows();
  var columnsContext = useTableColumns();
  var treeContext = useTableTree();
  var expansionContext = useTableExpansion();
  var columnsWidthContext = useTableColumnsWidth();
  var sectionsContext = useTableSections();
  return useMemo(function () {
    var elem = cep.elem;
    var isTable = implement.isTable,
        TBody = implement.TBody;
    var original = rowsContext.original,
        current = rowsContext.current;
    var deep = columnsContext.deep,
        leafColumns = columnsContext.leafColumns;
    var treeActions = treeContext.actions;
    var expansionActions = expansionContext.actions;
    var widthMap = columnsWidthContext.widthMap,
        stickyStartMap = columnsWidthContext.stickyStartMap,
        stickyEndMap = columnsWidthContext.stickyEndMap;
    var spanMethod = sectionsContext.spanMethod,
        rowProps = sectionsContext.rowProps,
        rowBordered = sectionsContext.rowBordered;
    var widthList = leafColumns.map(function (col) {
      return widthMap.get(col);
    });
    var stickyStartList = leafColumns.map(function (col) {
      return stickyStartMap.get(col);
    });
    var stickyEndList = leafColumns.map(function (col) {
      return stickyEndMap.get(col);
    });
    var noneStickyFirstColumn = leafColumns.find(function (col) {
      return !col.fixed;
    });
    var colKeyList = leafColumns.map(function (col) {
      return "col.".concat(col.path.join('.'));
    });
    var firstDataColumn = leafColumns.find(function (c) {
      return c.id !== SELECTION_COLUMN_ID;
    });
    var rendererRows = [];
    var rendererGrid = [];
    var whitespaceGrid = [];
    var index = 0;

    var createRenderer = function createRenderer(rows) {
      return rows.forEach(function (row) {
        var y = index;
        var rendererGridRow = rendererGrid[y] || (rendererGrid[y] = []);
        var whitespaceGridRow = whitespaceGrid[y] || (whitespaceGrid[y] = []);
        var path = row.path,
            children = row.children,
            rawRowIndex = row.rowIndex;
        var rowIndex = rawRowIndex + deep;
        var key = path.join('.');

        var _ref = rowProps(row) || {},
            _ref$rowHeight = _ref.rowHeight,
            propRowHeight = _ref$rowHeight === void 0 ? bodyRowHeight : _ref$rowHeight,
            rowAttrs = _objectWithoutProperties(_ref, _excluded2);

        rendererRows.push(function () {
          var notLast = y < rendererRows.length - 1;
          var rowHeight = propRowHeight && propRowHeight + (notLast && rowBordered && 1 || 0);
          return React.createElement(TableRow, _objectSpread(_objectSpread({
            rowHeight: rowHeight
          }, rowAttrs), {}, {
            key: "row.".concat(key),
            rowIndex: rowIndex
          }), rendererGridRow.map(function (cell) {
            return isFunction(cell) && cell();
          }));
        });
        leafColumns.forEach(function (col, x) {
          var cellProps = col.cellProps,
              render = col.render,
              colIndex = col.colIndex;

          var _spanMethod = spanMethod(row, col),
              rowSpan = _spanMethod.rowSpan,
              colSpan = _spanMethod.colSpan;

          var stickyStartInfo = stickyStartList[x];
          var stickyEndInfo = stickyEndList[x];

          if (rowSpan === 0 || colSpan === 0) {
            return;
          }

          var width;

          if (!isTable) {
            width = widthList[x];

            if (colSpan && colSpan > 1) {
              var end = Math.min(x + colSpan, leafColumns.length);

              for (var j = x + 1; j < end; j++) {
                width += widthList[j];
              }
            }
          }

          var height;

          if (!isTable && rowSpan && rowSpan > 1) {
            height = "".concat(rowSpan * 100, "%");

            for (var i = y + 1; i < y + rowSpan; i++) {
              var postOffsetGridRow = whitespaceGrid[i] || (whitespaceGrid[i] = []);

              for (var _j = x; _j < x + (colSpan || 1); _j++) {
                postOffsetGridRow[_j] = widthList[_j];
              }
            }
          }

          var offset = 0;

          for (var _j2 = x - 1; _j2 > 0; _j2--) {
            var preOffset = whitespaceGridRow[_j2];

            if (preOffset === undefined) {
              break;
            }

            offset += preOffset;
          }

          rendererGridRow[x] = function () {
            var treeTrigger = row.tree && col === firstDataColumn && treeActions.trigger(row);
            var expansionTrigger = row.expansion && col === firstDataColumn && expansionActions.trigger(row);
            return React.createElement(TableCell, _objectSpread(_objectSpread({}, cellProps(row)), {}, {
              key: colKeyList[x],
              stickyStart: stickyStartInfo === null || stickyStartInfo === void 0 ? void 0 : stickyStartInfo.value,
              stickyEnd: stickyEndInfo === null || stickyEndInfo === void 0 ? void 0 : stickyEndInfo.value,
              noneStickyFirst: col === noneStickyFirstColumn,
              offset: offset,
              width: width,
              height: height,
              rowSpan: rowSpan,
              colSpan: colSpan,
              rowIndex: rowIndex,
              colIndex: colIndex
            }), treeTrigger, expansionTrigger, render(row));
          };
        });

        if (row.expansion && row.expansion.active) {
          rendererRows.push(function () {
            return React.createElement(TableRow, {
              key: "row.expansionContent.".concat(key),
              rowIndex: rowIndex,
              expansionContent: true
            }, React.createElement(TableCell, {
              colSpan: leafColumns.length,
              rowIndex: rowIndex,
              colIndex: 1
            }, expansionActions.content(row)));
          });
        }

        index++;

        if (row.tree && row.tree.active && children) {
          if (children.length) {
            createRenderer(children);
          } else {
            var empty = treeActions.empty;

            if (empty) {
              rendererRows.push(function () {
                return React.createElement(TableRow, {
                  key: "row.treeEmpty.".concat(key),
                  rowIndex: rowIndex,
                  treeEmpty: true
                }, React.createElement(TableCell, {
                  colSpan: leafColumns.length,
                  rowIndex: rowIndex,
                  colIndex: 1
                }, isFunction(empty) ? empty(row) : empty));
              });
            }
          }
        }
      });
    };

    createRenderer(current);
    return React.createElement(TBody, _objectSpread(_objectSpread({}, attrs), {}, {
      className: elem('Body', {}, className),
      role: "rowgroup"
    }), rendererRows.map(function (row) {
      return row();
    }));
  }, [bodyRowHeight, cep, implement, rowsContext, columnsContext, treeContext, expansionContext, columnsWidthContext, sectionsContext]);
}